<template>
  <v-container class="cmpbk black--text" id="chkout-container">
    <!--      
   13 Souls Run APP v0.8.1
    Copyright (c) 2024 Blue Cover Six LLC / John Molt
    BCS grants Unlimited License to 13 Souls LLC and Jeff Von Molt -->
    <!-- One to pay a simple $20 Entry Fee
One to pay a $60 bundle fee (final price TBD, but includes a shirt and a medal)
One to pay/make a donation of any kind. -->

    <!-- cleint id  ATF2MqCIzTUeROKOMx0Lo42GbG5hWsyB_RmP4RLgFjp7EpAcJ1Wj82gi7YdPWykQY_UWi9KIC6F4kKie -->
    <!-- client secret EOel4VQoEJTLrK8kD85UJQGLJLN1B_fIW8oVgMtFAe2gF2Jvb7f_QrkcF0L-cmHCCQHn-Gmvuach0ibG -->
    <!-- apyment data tranfer Identity Token: 2Z4WIQBfk0-971VIgs-1ePKUCkCliu30wCBbiTzTSbA9E7xauWgc2nUT4wy -->

    <!-- live clien id  ARsANw-IHv9pr38UJNVCpCFIpwDdmEpcXZUsWmsH-X8Yg4GGPI-uVWeOV_O_528Vrr4zoCW3Nxijfw4L -->
    <!-- live secret EHd03YvrbAI1OvjBaz1VlVq6PHzE8JI9owQmeKwZlrPAqboCVfesQYpzpvO2DoeWpggMdBo3qQzw6TBa -->
    <h1 class="white--text">CHECKOUT</h1>
    <!-- <a
      class="white--text"
      href="https://www.paypal.com/ncp/payment/GP2C3MDWHJBPY"
      >Paypal</a
    > -->

    <h2 class="white--text mt-10">
      Donation Bundle includes a shirt and a medal $65
    </h2>
    <paypal_button
      :import="totalImport2"
      :description="description2"
      @paypal_done="paypal_done"
    />

    <!-- <a href="https://www.paypal.com/ncp/payment/4RYJLAE9VVRQA">Paypal</a> -->
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
#chkout-container {
  max-width: 768px;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import paypal_button from "../components/paypal_button.vue";
export default {
  name: "checkout2",
  components: {
    paypal_button,
  },
  mixins: [bus_common],
  // head: {
  //   script: [
  //     {
  //       type: "text/javascript",
  //       src: "https://www.paypalobjects.com/api/checkout.js",
  //     },
  //   ],
  // },
  data() {
    return {
      amountRules: [
        (v) => !!v || "Amount is required",
        (v) => v >= 20 || "Amount must greater than $20",
      ],
      totalImport1: "1",
      totalImport2: "65",
      totalImport3: "3",
      description1: "$20 Donation 13 Souls Run",
      description2: "$65 Donation 13 Souls Run Package",
      description3: "My Donation 13 Souls Run",
    };
  },

  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
